// src/data/seoKeywords.js
// One object per target keyword. Each powers its own component in /components/seo,
// so search engines get a dedicated, keyword-rich section and internal link for every phrase.

export const navaKailayamStops = [
  { n: 1, name: "Papanasam", planet: "Suriyan (Sun)", note: "Opening stop, beside Papanasam falls" },
  { n: 2, name: "Cheranmahadevi", planet: "Chandran (Moon)", note: "On the Thamirabarani bank" },
  { n: 3, name: "Kodaganallur", planet: "Chevvai (Mars)", note: "Near Nadukallur village" },
  { n: 4, name: "Kunnathur", planet: "Raghu", note: "Riverside shrine" },
  { n: 5, name: "Murappanadu", planet: "Guru (Jupiter)", note: "Midway point of the circuit" },
  { n: 6, name: "Sri Vaikundam", planet: "Sani (Saturn)", note: "Largest of the nine temples" },
  { n: 7, name: "Thenthiruperai", planet: "Kethu", note: "On the Tiruchendur road" },
  { n: 8, name: "Rajapathy", planet: "Budhan (Mercury)", note: "Quiet village shrine" },
  { n: 9, name: "Senthapoomangalam (Sevalur)", planet: "Sukran (Venus)", note: "Final stop of the pilgrimage" },
];

export const seoKeywords = {
  navaKailayamTaxi: {
    id: "navaKailayamTaxi",
    keyword: "taxi services in Nava Kailayam Temples",
    metaTitle: "Taxi Services in Nava Kailayam Temples | Aadvika Cabs",
    metaDescription:
      "Book a reliable taxi for the Nava Kailayam nine-temple circuit near Tirunelveli. AC sedans, SUVs and vans with drivers who know every stop on the route.",
    h1: "Taxi Services in Nava Kailayam Temples",
    intro:
      "Aadvika Cabs runs dedicated taxis for the Nava Kailayam pilgrimage, the nine Shiva shrines strung along the Thamirabarani river in Tirunelveli district. Our drivers cover this route every week, so timings, temple hours and the shortest road between each stop are second nature to them.",
    highlights: [
      "One taxi, one driver for the full nine-temple loop — no changeovers mid-route",
      "Early 6 AM pickup so all nine shrines are comfortable to finish in a single day",
      "AC sedans for small families, SUVs and vans for larger groups",
    ],
    faqs: [
      {
        q: "Can one taxi cover all nine Nava Kailayam temples in a day?",
        a: "Yes. Starting around 6 AM from Tirunelveli, most groups complete the full circuit and return by evening in the same taxi.",
      },
      {
        q: "Do your drivers wait at each temple?",
        a: "Yes, the taxi and driver wait at every stop, so you're never arranging a fresh pickup along the route.",
      },
    ],
  },

  navaKailayamCab: {
    id: "navaKailayamCab",
    keyword: "cab services in Nava Kailayam Temples",
    metaTitle: "Cab Services in Nava Kailayam Temples | Aadvika Cabs",
    metaDescription:
      "Aadvika Cabs offers point-to-point and full-circuit cab services for the Nava Kailayam temples, with sedans, SUVs, MUVs and tempo travellers for any group size.",
    h1: "Cab Services in Nava Kailayam Temples",
    intro:
      "Whether you need a single cab for two people or a tempo traveller for an extended family, Aadvika Cabs matches the right vehicle to your Nava Kailayam trip. Every cab comes with a driver familiar with temple timings, the river-side roads, and where to stop for breakfast along the way.",
    highlights: [
      "Choose from sedans, SUVs, MUVs, tempo travellers and coaches",
      "Flexible plans — full nine-temple circuit or a shorter selection of shrines",
      "Transparent, pre-confirmed fare with no last-minute surprises",
    ],
    faqs: [
      {
        q: "What cab is best for a family of 5–6 for Nava Kailayam?",
        a: "An Innova or Innova Crysta comfortably seats a family of 5–6 with luggage for a full-day temple circuit.",
      },
      {
        q: "Can I book a cab for only some of the nine temples?",
        a: "Yes, you can pick a shorter route covering select shrines instead of all nine — just tell us which stops matter most to you.",
      },
    ],
  },

  bookCabNavaKailayam: {
    id: "bookCabNavaKailayam",
    keyword: "Book a cab in Nava Kailayam Temples",
    metaTitle: "Book a Cab in Nava Kailayam Temples | Aadvika Cabs",
    metaDescription:
      "Book your Nava Kailayam temple cab online or by phone in minutes. Instant confirmation, fixed fares, and pickup from Tirunelveli town, railway station or your hotel.",
    h1: "Book a Cab in Nava Kailayam Temples",
    intro:
      "Booking a cab for the Nava Kailayam circuit takes minutes. Share your pickup point, group size and preferred start time, and we confirm a vehicle and driver before you hang up the phone.",
    highlights: [
      "Book by phone, WhatsApp or the form below — confirmed within the hour",
      "Pickup from the railway station, bus stand, or any hotel in Tirunelveli",
      "Fixed, all-inclusive fare shared before the trip begins",
    ],
    faqs: [
      {
        q: "How far in advance should I book?",
        a: "A day's notice is usually enough, though booking 2–3 days ahead guarantees your preferred vehicle during festival season.",
      },
      {
        q: "Is advance payment required to book?",
        a: "Most bookings are confirmed with just your details over phone or WhatsApp; payment is settled with the driver on the day.",
      },
    ],
  },

  tirunelveliToNavaKailayamCab: {
    id: "tirunelveliToNavaKailayamCab",
    keyword: "cab service from tirunelveli to Nava Kailayam temples",
    metaTitle: "Cab Service from Tirunelveli to Nava Kailayam Temples | Aadvika Cabs",
    metaDescription:
      "Direct cab service from Tirunelveli town, railway station or airport to all nine Nava Kailayam temples. Round-trip and drop-only options available.",
    h1: "Cab Service from Tirunelveli to Nava Kailayam Temples",
    intro:
      "Most Nava Kailayam pilgrims start from Tirunelveli, and that's exactly where our cabs are based. We pick up from the railway station, the bus stand, the airport, or your hotel, and drive the full loop along the Thamirabarani river before dropping you back in town.",
    highlights: [
      "Direct pickup from Tirunelveli Junction, hotels or the airport",
      "Round-trip cab that stays with you for the entire circuit",
      "Roughly 120–150 km covered across the nine temples, planned to avoid backtracking",
    ],
    faqs: [
      {
        q: "How far is the Nava Kailayam circuit from Tirunelveli?",
        a: "The full nine-temple loop covers roughly 120–150 km starting and ending in Tirunelveli.",
      },
      {
        q: "Can the cab pick us up directly from the railway station?",
        a: "Yes, our drivers regularly meet trains at Tirunelveli Junction and start the temple trip straight from the platform.",
      },
    ],
  },

  tirunelveliToNavaKailayamTaxi: {
    id: "tirunelveliToNavaKailayamTaxi",
    keyword: "taxi services from tirunelveli to Nava Kailayam temples",
    metaTitle: "Taxi Services from Tirunelveli to Nava Kailayam Temples | Aadvika Cabs",
    metaDescription:
      "Reliable taxi from Tirunelveli to the Nava Kailayam nine-temple circuit. Experienced drivers, AC vehicles, and pickup timings built around temple hours.",
    h1: "Taxi Services from Tirunelveli to Nava Kailayam Temples",
    intro:
      "An early start makes or breaks a Nava Kailayam day trip. Our taxis leave Tirunelveli around 6 AM, timed so you reach the first temple, Papanasam, right as the morning pooja finishes and the crowd is thin.",
    highlights: [
      "6 AM departure from Tirunelveli for a comfortable full-day circuit",
      "Driver-guided sequencing of all nine temples to avoid doubling back",
      "AC taxi with water and rest stops built into the plan",
    ],
    faqs: [
      {
        q: "What time should we start from Tirunelveli?",
        a: "Around 6 AM is ideal — it lets you finish all nine temples and be back in town by early evening.",
      },
      {
        q: "Is the taxi fare inclusive of driver allowance and tolls?",
        a: "Yes, the fare we confirm before the trip includes driver allowance and any tolls on the route.",
      },
    ],
  },

  tirunelveliCabServices: {
    id: "tirunelveliCabServices",
    keyword: "Cab services in tirunelveli",
    metaTitle: "Cab Services in Tirunelveli | Aadvika Cabs",
    metaDescription:
      "Aadvika Cabs is a Tirunelveli-based cab service for local travel, temple tours, railway station and hotel pickups, and outstation trips across Tamil Nadu.",
    h1: "Cab Services in Tirunelveli",
    intro:
      "Aadvika Cabs is based in Tirunelveli and serves everything from a quick trip across town to multi-day outstation tours. Our fleet spans sedans, SUVs, MUVs, tempo travellers and coaches, so one call covers a solo traveller and a 25-person tour group alike.",
    highlights: [
      "Local, outstation and temple-circuit trips from one Tirunelveli-based fleet",
      "12 vehicle types — from a 4-seat sedan to a 25-seater coach",
      "24/7 phone support with confirmed pickup at any Tirunelveli location",
    ],
    faqs: [
      {
        q: "Does Aadvika Cabs handle both local and outstation trips?",
        a: "Yes, we run city trips within Tirunelveli as well as outstation and multi-day tours across Tamil Nadu.",
      },
      {
        q: "What vehicles are available in Tirunelveli?",
        a: "Our Tirunelveli fleet includes sedans, SUVs, MUVs, tempo travellers, tourist vans and coaches up to 25 seats.",
      },
    ],
  },

  railwayStationCabs: {
    id: "railwayStationCabs",
    keyword: "Tirunelveli railway station taxi and cab pickup",
    metaTitle: "Tirunelveli Railway Station Taxi & Cab Pickup | Aadvika Cabs",
    metaDescription:
      "Book a taxi or cab pickup at Tirunelveli Junction railway station. On-time drivers for onward travel to the city, hotels, or the Nava Kailayam temples.",
    h1: "Tirunelveli Railway Station Taxi & Cab Pickup",
    intro:
      "Trains into Tirunelveli Junction don't always run to schedule, so our drivers track your train and adjust pickup timing automatically. Step off the platform and your cab is already waiting, whether you're headed into town, to a hotel, or straight onward to the Nava Kailayam temples.",
    highlights: [
      "Live train tracking so the driver adjusts to delays automatically",
      "Meet-and-greet at the platform with a name board on request",
      "Direct onward trip to hotels, the city, or the temple circuit — no waiting around",
    ],
    faqs: [
      {
        q: "What happens if my train is delayed?",
        a: "Our drivers track the train and adjust the pickup time, so you won't be charged extra or left waiting for a new cab.",
      },
      {
        q: "Can I go straight from the station to the Nava Kailayam temples?",
        a: "Yes, many pilgrims begin the temple circuit directly from the station — just let us know when booking.",
      },
    ],
  },

  hotelCabs: {
    id: "hotelCabs",
    keyword: "hotel pickup and drop cab services Tirunelveli",
    metaTitle: "Hotel Pickup & Drop Cab Services in Tirunelveli | Aadvika Cabs",
    metaDescription:
      "Cab pickup and drop from any hotel in Tirunelveli. Scheduled trips for sightseeing, temple visits, or onward travel, arranged around your stay.",
    h1: "Hotel Pickup & Drop Cab Services in Tirunelveli",
    intro:
      "Tell us your hotel and check-out time, and we'll have a cab at the entrance when you need it. Many guests also pre-book a temple day trip or an early-morning Nava Kailayam departure straight from their room.",
    highlights: [
      "Pickup and drop at any hotel or guesthouse in Tirunelveli",
      "Same-day and advance bookings for sightseeing or temple trips",
      "Coordination with your check-in/check-out time, including early departures",
    ],
    faqs: [
      {
        q: "Can I book a cab in advance for an early morning hotel pickup?",
        a: "Yes, early Nava Kailayam departures around 6 AM are one of our most common hotel pickup requests.",
      },
      {
        q: "Do you serve hotels outside the town centre?",
        a: "Yes, we pick up and drop at hotels and resorts across Tirunelveli and its surrounding areas.",
      },
    ],
  },
};

export const seoKeywordOrder = [
  "navaKailayamTaxi",
  "navaKailayamCab",
  "bookCabNavaKailayam",
  "tirunelveliToNavaKailayamCab",
  "tirunelveliToNavaKailayamTaxi",
  "tirunelveliCabServices",
  "railwayStationCabs",
  "hotelCabs",
];